import { SET_PRODUCT, IProduct } from './types'

export function setProduct (product: IProduct) {
  return {
    type: SET_PRODUCT,
    payload: product
  }
}
